/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlGroupSummary } from './ControlGroupSummary';
import {
    ControlGroupSummaryFromJSON,
    ControlGroupSummaryFromJSONTyped,
    ControlGroupSummaryToJSON,
} from './ControlGroupSummary';
import type { ControlJSONLog } from './ControlJSONLog';
import {
    ControlJSONLogFromJSON,
    ControlJSONLogFromJSONTyped,
    ControlJSONLogToJSON,
} from './ControlJSONLog';
import type { ControlStatus2 } from './ControlStatus2';
import {
    ControlStatus2FromJSON,
    ControlStatus2FromJSONTyped,
    ControlStatus2ToJSON,
} from './ControlStatus2';
import type { ControlVerdict3 } from './ControlVerdict3';
import {
    ControlVerdict3FromJSON,
    ControlVerdict3FromJSONTyped,
    ControlVerdict3ToJSON,
} from './ControlVerdict3';

/**
 * 
 * @export
 * @interface ControlCustomCase
 */
export interface ControlCustomCase {
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    autoContained?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCustomCase
     */
    categories?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    clientNotified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    closedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    contained: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    containsHVA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    containsMobile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    containsVIP: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof ControlCustomCase
     */
    detectionCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCustomCase
     */
    detectionSids: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    excludeFromMeans: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    externalTicketId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    externalTicketIntegrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    firstDetectionSourceDetectedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    firstDetectionSourceIngestedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    firstRun: boolean;
    /**
     * 
     * @type {Array<ControlGroupSummary>}
     * @memberof ControlCustomCase
     */
    groupSummaries?: Array<ControlGroupSummary>;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    groups?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    hasPassedAql?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    lastNotifiedClientAt?: string;
    /**
     * 
     * @type {Array<ControlJSONLog>}
     * @memberof ControlCustomCase
     */
    logs: Array<ControlJSONLog>;
    /**
     * 
     * @type {number}
     * @memberof ControlCustomCase
     */
    mttr?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    notes?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCustomCase
     */
    platforms?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    reingested: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    respondedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    severity: string;
    /**
     * 
     * @type {number}
     * @memberof ControlCustomCase
     */
    severityOrdinal: number;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    sid: string;
    /**
     * 
     * @type {ControlStatus2}
     * @memberof ControlCustomCase
     */
    status: ControlStatus2;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    teamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCustomCase
     */
    testMode: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    updatedAt?: string;
    /**
     * 
     * @type {ControlVerdict3}
     * @memberof ControlCustomCase
     */
    verdict: ControlVerdict3;
    /**
     * 
     * @type {string}
     * @memberof ControlCustomCase
     */
    verdictedAt?: string;
}

/**
 * Check if a given object implements the ControlCustomCase interface.
 */
export function instanceOfControlCustomCase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contained" in value;
    isInstance = isInstance && "containsHVA" in value;
    isInstance = isInstance && "containsMobile" in value;
    isInstance = isInstance && "containsVIP" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "detectionSids" in value;
    isInstance = isInstance && "excludeFromMeans" in value;
    isInstance = isInstance && "firstDetectionSourceDetectedAt" in value;
    isInstance = isInstance && "firstDetectionSourceIngestedAt" in value;
    isInstance = isInstance && "firstRun" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "logs" in value;
    isInstance = isInstance && "reingested" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "severityOrdinal" in value;
    isInstance = isInstance && "sid" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "testMode" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "verdict" in value;

    return isInstance;
}

export function ControlCustomCaseFromJSON(json: any): ControlCustomCase {
    return ControlCustomCaseFromJSONTyped(json, false);
}

export function ControlCustomCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCustomCase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoContained': !exists(json, 'autoContained') ? undefined : json['autoContained'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'clientNotified': !exists(json, 'clientNotified') ? undefined : json['clientNotified'],
        'closedAt': !exists(json, 'closedAt') ? undefined : json['closedAt'],
        'contained': json['contained'],
        'containsHVA': json['containsHVA'],
        'containsMobile': json['containsMobile'],
        'containsVIP': json['containsVIP'],
        'createdAt': json['createdAt'],
        'detectionCount': !exists(json, 'detectionCount') ? undefined : json['detectionCount'],
        'detectionSids': json['detectionSids'],
        'excludeFromMeans': json['excludeFromMeans'],
        'externalTicketId': !exists(json, 'externalTicketId') ? undefined : json['externalTicketId'],
        'externalTicketIntegrationId': !exists(json, 'externalTicketIntegrationId') ? undefined : json['externalTicketIntegrationId'],
        'firstDetectionSourceDetectedAt': json['firstDetectionSourceDetectedAt'],
        'firstDetectionSourceIngestedAt': json['firstDetectionSourceIngestedAt'],
        'firstRun': json['firstRun'],
        'groupSummaries': !exists(json, 'groupSummaries') ? undefined : ((json['groupSummaries'] as Array<any>).map(ControlGroupSummaryFromJSON)),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'hasPassedAql': !exists(json, 'hasPassedAql') ? undefined : json['hasPassedAql'],
        'id': json['id'],
        'lastNotifiedClientAt': !exists(json, 'lastNotifiedClientAt') ? undefined : json['lastNotifiedClientAt'],
        'logs': ((json['logs'] as Array<any>).map(ControlJSONLogFromJSON)),
        'mttr': !exists(json, 'mttr') ? undefined : json['mttr'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'platforms': !exists(json, 'platforms') ? undefined : json['platforms'],
        'reingested': json['reingested'],
        'respondedAt': !exists(json, 'respondedAt') ? undefined : json['respondedAt'],
        'severity': json['severity'],
        'severityOrdinal': json['severityOrdinal'],
        'sid': json['sid'],
        'status': ControlStatus2FromJSON(json['status']),
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'testMode': json['testMode'],
        'title': json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'verdict': ControlVerdict3FromJSON(json['verdict']),
        'verdictedAt': !exists(json, 'verdictedAt') ? undefined : json['verdictedAt'],
    };
}

export function ControlCustomCaseToJSON(value?: ControlCustomCase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autoContained': value.autoContained,
        'categories': value.categories,
        'clientNotified': value.clientNotified,
        'closedAt': value.closedAt,
        'contained': value.contained,
        'containsHVA': value.containsHVA,
        'containsMobile': value.containsMobile,
        'containsVIP': value.containsVIP,
        'createdAt': value.createdAt,
        'detectionCount': value.detectionCount,
        'detectionSids': value.detectionSids,
        'excludeFromMeans': value.excludeFromMeans,
        'externalTicketId': value.externalTicketId,
        'externalTicketIntegrationId': value.externalTicketIntegrationId,
        'firstDetectionSourceDetectedAt': value.firstDetectionSourceDetectedAt,
        'firstDetectionSourceIngestedAt': value.firstDetectionSourceIngestedAt,
        'firstRun': value.firstRun,
        'groupSummaries': value.groupSummaries === undefined ? undefined : ((value.groupSummaries as Array<any>).map(ControlGroupSummaryToJSON)),
        'groups': value.groups,
        'hasPassedAql': value.hasPassedAql,
        'id': value.id,
        'lastNotifiedClientAt': value.lastNotifiedClientAt,
        'logs': ((value.logs as Array<any>).map(ControlJSONLogToJSON)),
        'mttr': value.mttr,
        'name': value.name,
        'notes': value.notes,
        'platforms': value.platforms,
        'reingested': value.reingested,
        'respondedAt': value.respondedAt,
        'severity': value.severity,
        'severityOrdinal': value.severityOrdinal,
        'sid': value.sid,
        'status': ControlStatus2ToJSON(value.status),
        'summary': value.summary,
        'teamId': value.teamId,
        'teamName': value.teamName,
        'testMode': value.testMode,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'verdict': ControlVerdict3ToJSON(value.verdict),
        'verdictedAt': value.verdictedAt,
    };
}

